var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnleaveProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.9994 40.3517C32.1245 40.3517 40.3327 32.1437 40.3327 22.0184C40.3327 11.8932 32.1245 3.68506 21.9994 3.68506C11.8741 3.68506 3.66602 11.8932 3.66602 22.0184C3.66602 32.1437 11.8741 40.3517 21.9994 40.3517Z",
    fill: "#6E6284"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.7231C18.205 12.7231 15.125 15.8031 15.125 19.5981C15.125 23.3197 18.04 26.3447 21.9083 26.4547C21.9633 26.4547 22.0367 26.4547 22.0733 26.4547C22.11 26.4547 22.165 26.4547 22.2017 26.4547C22.22 26.4547 22.2383 26.4547 22.2383 26.4547C25.9417 26.3264 28.8567 23.3197 28.875 19.5981C28.875 15.8031 25.795 12.7231 22 12.7231Z",
    fill: "#6E6284"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4303 35.4933C31.167 38.4999 26.8036 40.3516 22.0003 40.3516C17.197 40.3516 12.8336 38.4999 9.57031 35.4933C10.0103 33.8249 11.202 32.3033 12.9436 31.1299C17.9486 27.7933 26.0886 27.7933 31.057 31.1299C32.817 32.3033 33.9903 33.8249 34.4303 35.4933Z",
    fill: "#6E6284"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnleaveProfile);
export default __webpack_public_path__ + "static/media/onleaveProfile.f50dea53e16a89d6b38a199accc0fd43.svg";
export { ForwardRef as ReactComponent };